import { render } from "./InvoicesSeriesView.vue?vue&type=template&id=45dc252c"
import script from "./InvoicesSeriesView.vue?vue&type=script&lang=js"
export * from "./InvoicesSeriesView.vue?vue&type=script&lang=js"

import "./InvoicesSeriesView.vue?vue&type=style&index=0&id=45dc252c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/InvoicesSeriesView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45dc252c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45dc252c', __exports__)) {
    api.reload('45dc252c', __exports__)
  }
  
  module.hot.accept("./InvoicesSeriesView.vue?vue&type=template&id=45dc252c", () => {
    api.rerender('45dc252c', render)
  })

}


export default __exports__